var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{class:_vm.cssClass,attrs:{"show":_vm.busy,"rounded":"","opacity":"0.6","spinner-small":"","spinner-variant":_vm.spinnerVariant}},[_c('b-button',_vm._b({attrs:{"disabled":_vm.busy || _vm.disabled,"variant":_vm.variant},on:{"click":_vm.click}},'b-button',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }